import Button from "components/Button";
import Grid from "components/Grid";
import Loader from "components/Loader";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import { FC, useEffect } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { RiDeleteBin5Line } from "react-icons/ri";
import theme from "theme";
import {
    ButtonContainer,
    CircularButton,
} from "../../PersonalDetails/PersonalDetails.styled";
import { useSocialMedia } from "./useSocialMedia";

export const SocialMedia: FC = () => {
    const {
        socialHandles,
        addSocialHandle,
        isLoading,
        handleSubmit,
        removeSocialHandle,
        socialPlatformsOptions,
        handleSocialSelect,
        handleSocialUsername,
        isFetchingData,
    } = useSocialMedia();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    return (
        <PageContent>
            <ProfileContentWrapper>
                {isFetchingData && <Loader size={28} />}
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (3/3)
                </Text>
                <SubHeading variant="label">
                    Social Media <StraightLine />
                </SubHeading>
                {socialHandles.map((handle) => (
                    <Grid
                        key={handle.id}
                        row
                        expanded
                        marginTop={2}
                        columnGap={1}
                        rowGap={1}
                    >
                        <SingleSelect
                            label="Social"
                            required
                            minWidth="250px"
                            options={socialPlatformsOptions}
                            value={handle.social_platforms_id}
                            onChange={(value: any) =>
                                handleSocialSelect(value, handle.id)
                            }
                        />
                        <TextInput
                            name="userId"
                            label="User ID"
                            required
                            placeholder="Enter user id"
                            labelColor={theme.colors.text}
                            value={handle.username}
                            minWidth="250px"
                            onChange={(event) =>
                                handleSocialUsername(event, handle.id)
                            }
                        />
                        <ButtonContainer>
                            <CircularButton
                                type="button"
                                variant="flat"
                                disabled={socialHandles.length === 1}
                                onClick={() => removeSocialHandle(handle.id)}
                            >
                                <RiDeleteBin5Line color="red" />
                            </CircularButton>
                            <CircularButton
                                type="button"
                                variant="flat"
                                onClick={addSocialHandle}
                            >
                                <AiOutlinePlus color="green" fontWeight={700} />
                            </CircularButton>
                        </ButtonContainer>
                    </Grid>
                ))}
                <Grid
                    row={true}
                    columnGap={1}
                    marginTop={2}
                    marginBottom={1}
                    rowGap={1}
                >
                    <Button
                        variant="filled"
                        isLoading={isLoading}
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                </Grid>
            </ProfileContentWrapper>
        </PageContent>
    );
};
